export default "__VITE_ASSET__CIgeQMMl__"